import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-rma-shipping-arrivals-detail',
  templateUrl: './rma-shipping-arrivals-detail.component.html',
  styleUrls: ['./rma-shipping-arrivals-detail.component.css']
})
export class RmaShippingArrivalsDetailComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
